import { createReducer } from '@reduxjs/toolkit'

import { getMerchantWithdrawFeeAction, resetGetMerchantWithdrawFeeAction } from '../../../actions'

type State = {
  loading: boolean
  data?: {
    value: string
    converted: string
  }
}

const initialState: State = { loading: false, data: undefined }

export const getWithdrawFee = createReducer(initialState, (builder) => {
  builder
    .addCase(getMerchantWithdrawFeeAction.pending, (state) => {
      state.loading = true
      state.data = initialState.data
    })
    .addCase(getMerchantWithdrawFeeAction.rejected, (state) => {
      state.loading = false
    })
    .addCase(getMerchantWithdrawFeeAction.fulfilled, (state, action) => {
      state.loading = false
      state.data = action.payload
    })
    .addCase(resetGetMerchantWithdrawFeeAction, () => initialState)
})
